import searchSelectFormat from '@/utils/searchSelectFormat';
import { triggerEvent } from '@/utils/convert';
export const sTriggerName = {
    id: 1,
    text: $t('integration.trigger_name_'),
    type: 'input',
    paramsName: 'triggerName',
    isChooze: true
};

export const sEvent = {
    id: 2,
    text: $t('integration.event'),
    type: 'select',
    paramsName: 'event',
    isChooze: false,
    selectParam: searchSelectFormat(triggerEvent)
};
export const sCarrier = {
    id: 3,
    text: $t('integration.monitoring_point'),
    type: 'input',
    paramsName: 'carrierName',
    isChooze: false
};
export const sOperator = {
    id: 4,
    text: $t('integration.operator'),
    type: 'input',
    paramsName: 'operator',
    isChooze: false
};
export const sOperationTime = {
    id: 5,
    text: $t('integration.operation_time'),
    type: 'datetimerange',
    paramsName: 'time',
    isChooze: false
};
export const sCustomer = {
    id: 6,
    text: $t('integration.customer'),
    type: 'select',
    selectParam: [],
    paramsName: 'sceneId',
    isChooze: false
};
